import { FormElementModel } from "../../../models/FormElementModel";
import { emailValidator, lengthValidator, phoneValidator } from "../../../../utils/formsValidation";
import { t } from "i18next";

export const guardianRegisterForm = (watch: any, register: any): FormElementModel[] => [
  {
    name: "firstName",
    type: "text",
    text: t("imie"),
    isLabel: true,
    register: { ...register("firstName", { ...lengthValidator(true, 3) }) },
  },
  {
    name: "lastName",
    type: "text",
    text: t("nazwisko"),
    isLabel: true,
    register: { ...register("lastName", { ...lengthValidator(true, 3) }) },
  },
  {
    name: "email",
    type: "text",
    text: "E-mail",
    isLabel: true,
    register: { ...register("email", { ...emailValidator(true) }) },
  },
  {
    name: "phone",
    type: "text",
    text: t("telefon_kontaktowy"),
    isLabel: true,
    register: { ...register("phone", { ...phoneValidator(true) }) },
  },
  // {
  //   name: "password",
  //   type: "password",
  //   text: t("haslo"),
  //   isLabel: true,
  //   register: { ...register("password", { ...passValidator(true) }) },
  // },
  // {
  //   name: "repeatPassword",
  //   type: "password",
  //   text: t("powtorz_haslo"),
  //   isLabel: true,
  //   register: { ...register("repeatPassword", { ...repeatPassValidator(true, watch("password", "")) }) },
  // },
];

